export function getRandomInt({ max }: { max: number }) {
  return Math.floor(Math.random() * max)
}
